<template>
  <div class="user-modal-body">
    <h3 class="text-center mb-4">{{name}}</h3>

    <template v-if="isEstablishment || isPartner">
      <section class="mb-3">
        <h4 class="text-muted text-center">
          {{$t('message.admSettings.message.access')}}
        </h4>

        <div v-if="loginBlocked"
             class="text-center">

          <button class="btn btn-round btn-primary"
                  @click="unlockLogin()">{{$t('message.admSettings.message.unblockMasterLogin')}}</button>
        </div>
        <div v-if="!lastLogin"
             class="text-center">
          <button class="btn btn-round btn-primary"
                  @click="resendWelcomeEmail()">{{$t('message.admSettings.message.resendWelcomeEmail')}}</button>
        </div>

        <div class="text-center">
          <button class="btn btn-round btn-primary"
                  @click="getPasswordRecoveryLink()">{{$t('message.admSettings.message.linkResetPassword')}}</button>
        </div>
      </section>
      <section class="mb-3"
               v-if="!isPartner && !isPartnerLogged">
        <h4 class="text-muted text-center">
            {{$t('message.admSettings.message.report')}}
        </h4>

        <div class="text-center">
          <button class="btn btn-round btn-primary"
                  @click="sendPerformanceEmail()">{{$t('message.admSettings.message.sendMonthlyPerformanceEmail')}}</button>
        </div>
      </section>

      <section class="mb-3">
        <h4 class="text-muted text-center">
            {{$t('message.generics.message.settings')}}
        </h4>
        <div class="text-center" v-if="!isPartnerLogged">
          <button class="btn btn-round btn-primary"
                  @click="openDataWifiForm">{{$t('message.admSettings.message.dataWifiCredentials')}}</button>
        </div>

        <toggles-section :value="userPermissions"
                         :permissions="permissions"
                         @toggle="togglePermission">
        </toggles-section>
      </section>
      
      <data-wifi-form v-if="showingDataWifiForm" v-model="showingDataWifiForm" :establishmentId="entityId"/>
    </template>
  </div>
</template>

<script>
// import AppTogglesSection from "./sections/TogglesSection";
import EventBus from "@packages/event-bus";
import DataWifiForm from "./data-wifi/form/DataWifiForm.vue";
import TogglesSection from "./sections/TogglesSection";

export default {
  components: {
    // AppTogglesSection,
    TogglesSection,
    DataWifiForm
  },

  data() {
    return {
      id: null,
      name: null,
      entity: null,
      password: null,
      clearAccess: null,
      lastLogin: null,
      loginBlocked: null,
      userPermissions: [],
      showingDataWifiForm: false,
    };
  },

  props: {
    permissions: {
      type: Array,
      default() {
        return [];
      },
    },
    entityId: {
      type: Number,      
    }
  },

  computed: {
    isEstablishment() {
      return this.entity === "establishments";
    },
    isPartner() {
      return this.entity === "partners";
    },
    isPartnerLogged() {
      return (
        this.$store.state.users.user != null &&
        this.$store.state.users.user.tipo === "PARCEIRO"
      );
    },
  },

  methods: {
    async togglePermission(permissionKey) {
      try {
        if (this.isPartner) {
          await this.$api.partners.togglePermission({
            partnerId: this.id,
            permissionKey,
          });
        } else {
          await this.$api.establishments.togglePermission({
            establishmentId: this.id,
            permissionKey,
          });
        }
      } catch (error) {
        console.log(error);
      }
    },

    async getPasswordRecoveryLink() {
      try {
        const res = await this.$api.auth.getMasterPasswordRecoveryLink({
          id: this.id,
        });

        await navigator.clipboard
          .writeText(res)
          .then(() => {
            EventBus.$emit("show-message", {
              type: "SUCCESS",
              message:
                "O link de redefinição de senha está na área de transferência. Utilize Ctrl + V para colar no local desejado.",
            });
          })
          .catch(() => {
            EventBus.$emit("show-message", {
              type: "ERROR",
              message: "Problemas ao copiar texto de redefinição de senha!",
            });
          });
      } catch (error) {
        console.log(error);
      }
    },
    async resendWelcomeEmail() {
      try {
        await this.$api.auth.resendWelcomeEmail({ id: this.userId });

        EventBus.$emit("show-message", {
          type: "SUCCESS",
          message: "Re-envio de e-mail de Boas vindas feito com Sucesso.",
          timeout: 2000,
        });
      } catch (error) {
        console.log(error);
      }
    },
    async sendPerformanceEmail() {
      try {
        await this.$api.auth.sendPerformanceEmail({ id: this.userId });

        EventBus.$emit("show-message", {
          type: "SUCCESS",
          message: "Enviado Email de Performance Mensal.",
          timeout: 2000,
        });
      } catch (error) {
        console.log(error);
      }
    },
    reset({ entity, user }) {
      this.userId = user.userId;
      this.id = user.id;
      this.name = user.general.name;
      this.entity = entity;
      this.lastLogin = user.lastLogin;
      this.loginBlocked = user.loginBlocked;
      this.userPermissions = user.permissions;
    },

    async unlockLogin() {
      const res = await this.$api.auth.unlockLogin({ id: this.userId });
      EventBus.$emit("show-message", {
        type: "SUCCESS",
        message: res.message,
        timeout: 2000,
      });
    },

    async submitClearAccess() {
      const res = await this.$api.establishments.clearAccess({
        establishmentId: this.id,
        email: this.clearAccess,
      });

      this.clearAccess = null;

      EventBus.$emit("show-message", {
        type: "SUCCESS",
        message: res.message,
        timeout: 2000,
      });
    },

    openDataWifiForm() {
      this.showingDataWifiForm = true
    }
  },

  watch: {},

  mounted() {
    EventBus.$on("RESET_USER_MODAL", this.reset);
  },

  beforeDestroy() {
    EventBus.$off("RESET_USER_MODAL", this.reset);
  },
};
</script>

<style lang="scss" scoped>
.user-modal-body {
  padding: 30px 100px;

  .btn-primary {
    font-size: 14px;
    padding: 4px 22px;
    margin: 10px 0 16px 20px;
    border-radius: 24px;
    flex-grow: 0;
  }
}
</style>
